import pickBy from 'lodash/pickBy';

export const mapCommunityApp = (values, appInstallationTag, communityTag) =>
  pickBy(
    {
      version: values.version,
      alias: values.alias,
      url: values.url,
      community: { tag: communityTag },
      appInstallation: { tag: appInstallationTag },
      communityAppFeatures: (values.communityAppFeatures || [])
        .map(feature =>
          pickBy(
            {
              ...feature,
              communityAppFeatureRoles: (feature.communityAppFeatureRoles || []).map(tag => ({
                appInstallationFeatureRole: { tag },
              })),
              requiresSubscription: Boolean(feature.requiresSubscription),
            },
            v => v !== null && v !== undefined && v !== ''
          )
        )
        .filter(f => (f.communityAppFeatureRoles || []).length > 0),
    },
    v => v !== null && v !== undefined && v !== ''
  );
